import { ReactNode } from "react";

export default function LabeledContentRow({
  label,
  content,
  contentStyle,
  size = "m",
}: {
  label: string;
  content: string | ReactNode;
  contentStyle?: object;
  size?: "m" | "s";
}) {
  return (
    <div className="nds-grid nds-span-9">
      <div className="nds-span-4" style={{ minWidth: size === "m" ? "180px" : "120px" }}>
        <p className="padding--bottom--xs" style={{ fontWeight: "600" }}>
          {label}
        </p>
      </div>
      <div className="nds-span-8">
        <p className="padding--bottom--xs" style={contentStyle}>
          {content}
        </p>
      </div>
    </div>
  );
}
